import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataProvider } from 'src/providers/data/data';

@Component({
  selector: 'app-apply-edit-comp',
  templateUrl: './apply-edit-comp.component.html',
  styleUrls: ['./apply-edit-comp.component.scss'],
})
export class ApplyEditCompComponent implements OnInit {
  constructor(
    private router: Router,
    public data: DataProvider,
    private route: ActivatedRoute,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    this.data.menuPageTitle = 'wf-contract-apply-list';
    this.widthChanger('main-header', 360);
  }

  back() {
    this.router.navigate(['/wf-contract-apply-list']);
  }
  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          
          header.style.minWidth = width.toString() + 'px';
      }
  }
}
